// One guess-distribution chart for the whole site (CLAUDE.md: One
// guess-distribution chart): the same bars, the same labels, in the Stats modal
// and on a result screen. The only difference a result screen makes is that the
// player's own row is highlighted — nothing else changes.
//
// Bars are a share of 100%, never of the tallest bar: a 39% bar fills 39% of the
// width, and there is no track behind it.
import './Distribution.css';

export const MISSED = 'Missed';
export const guessLabel = (n: number) => `Guess ${n}`;

export interface DistRow {
  label: string;     // Guess 1, Guess 2, Guess 3, Missed
  value: string;     // a percentage on a result screen, a count in the modal
  pct: number;       // 0–100: the width of the bar
  own?: boolean;     // the row this player landed on, on a result screen
}

export function Distribution({ rows }: { rows: DistRow[] }) {
  return (
    <div className="dist">
      {rows.map((row) => (
        <div
          className={`dist-row${row.own ? ' is-own' : ''}${row.label === MISSED ? ' is-missed' : ''}`}
          key={row.label}
        >
          <span className="dist-label">{row.label}</span>
          <span className="dist-bars">
            <span className="dist-bar" style={{ width: `${row.pct}%` }} />
            <span className="dist-value">{row.value}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
